import { isNumber } from "lodash";
import { forwardRef } from "react";

import type { Icon, IconProps } from "@tabler/icons-react";

export const IconCurrencyEuro = forwardRef<Icon, IconProps>(
  ({ size = 24, stroke = "none", ...props }, ref) => {
    const currentStroke = isNumber(stroke) ? `${stroke}px` : stroke;

    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="currentColor"
        stroke={currentStroke}
        {...props}
        ref={ref as any}
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M4 12C4 7.58172 7.58172 4 12 4C16.4183 4 20 7.58172 20 12C20 16.4183 16.4183 20 12 20C7.58172 20 4 16.4183 4 12ZM12 2C6.47716 2 2 6.47716 2 12C2 17.5229 6.47716 22 12 22C17.5229 22 22 17.5229 22 12C22 6.47716 17.5229 2 12 2ZM7.86747 11.8603L7.88296 12.3073H7V13.7737H7.9759C8.21343 14.77 8.74527 15.5568 9.57143 16.1341C10.3976 16.7114 11.4251 17 12.654 17C13.8933 17 15.0086 16.7579 16 16.2737L15.3804 14.8492C14.358 15.2123 13.475 15.3939 12.7315 15.3939C11.42 15.3939 10.5938 14.8538 10.253 13.7737H13.506V12.3073H10.1446C10.1343 12.2142 10.1291 12.1257 10.1291 12.0419C10.1291 11.9488 10.1394 11.8277 10.1601 11.6788H13.506V10.1983H10.315C10.7074 9.13687 11.6007 8.60615 12.9948 8.60615C13.7384 8.60615 14.4406 8.73184 15.1015 8.98324L15.6902 7.41899C14.7504 7.13967 13.8417 7 12.9639 7C11.673 7 10.599 7.28399 9.74182 7.85195C8.89501 8.41993 8.33219 9.20205 8.05336 10.1983H7V11.6648H7.89845C7.8778 11.7579 7.86747 11.8231 7.86747 11.8603Z"
        />
      </svg>
    );
  }
);
